require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-eventi-architettura-e-monumento-tra-italia-e-ticino-insegnamento-dialogo-progetto.json") })
        }
      }, "path---en-eventi-architettura-e-monumento-tra-italia-e-ticino-insegnamento-dialogo-progetto");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-eventi-architettura-e-monumento-tra-italia-e-ticino-insegnamento-dialogo-progetto!./.cache/json/en-eventi-architettura-e-monumento-tra-italia-e-ticino-insegnamento-dialogo-progetto.json
// module id = 563
// module chunks = 231608221292675